import { Text } from '@fluentui/react';
import React from 'react';
import { IMarkerSet } from 'views/BlueRelationship/Compare/Compare.constants';
import { FONT_FAMILY_STYLES } from './PharmacyPlan.constants';

interface ICompareNavTextProps {
    changed?: boolean;
    label?: string;
    onClick: () => void;
    style?: React.CSSProperties;
    variant?: 'small' | 'smallPlus';
    markers: IMarkerSet
}

const LINK_TEXT_STYLES = { root: { cursor: 'pointer' } };

const CompareNavText: React.FC<ICompareNavTextProps> = React.memo((props) => {
    const { label, onClick, style, variant } = props;

    const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
        }
    };

    return (
        <Text
            styles={LINK_TEXT_STYLES}
            style={style}
            variant={variant}
            onClick={onClick}
            tabIndex={0}
            role='button'
            onKeyDown={handleKeyDown}
        >
            <span style={FONT_FAMILY_STYLES}>
                {props.changed ? props.markers.MARKER_ON : props.markers.MARKER_OFF}
            </span>
            {label}
        </Text>
    );
});

export default CompareNavText;